import React from "react";
import styles from "./Withus.module.css";
import benefit1Image from "../../../assets/images/withus1.png";
import benefit2Image from "../../../assets/images/withus2.png";
import benefit3Image from "../../../assets/images/withus3.png";
import benefit4Image from "../../../assets/images/withus4.png";
import benefit5Image from "../../../assets/images/withus5.png";
import benefit6Image from "../../../assets/images/withus6.png";
import { Animate, Stagger } from "../../animations";

const benefits = [
  { image: benefit1Image, title: "Experienced Team", desc: "8+ years of study-abroad expertise" },
  { image: benefit2Image, title: "Quality Service", desc: "94% visa approval success rate" },
  { image: benefit3Image, title: "Customer Satisfaction", desc: "5,000+ students placed abroad" },
  { image: benefit4Image, title: "Fast Processing", desc: "Average visa in 4-6 weeks" },
  { image: benefit5Image, title: "Custom Solutions", desc: "Tailored plans for every student" },
  { image: benefit6Image, title: "Affordable Pricing", desc: "Packages starting at ₹4,999" },
];

const WithUs = () => {
  return (
    <section className={styles.withUsContainer}>
      <div className={styles.withUsInner}>
        <Animate variant="fadeUp">
          <h4 className={styles.heading}>Why Choose Us</h4>
          <h1 className={styles.subHeading} id="heading-large">
            Benefits of Working With Ever Sky
          </h1>
        </Animate>
        <Stagger
          className={styles.benefitsSection}
          as="div"
          variant="fadeUp"
          stagger={80}
        >
          {benefits.map((b) => (
            <div key={b.title} className={styles.benefit}>
              <img src={b.image} alt={b.title} />
              <h2 id="heading-md">{b.title}</h2>
              <p className="text-gray-600 text-sm mt-1">{b.desc}</p>
            </div>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default WithUs;
